<template>
  <card id="gatewayPosition" no-header no-footer no-padding>
    <div slot="card-body" class="row no-gutters">
      <div class="col-md-8 col-xl-9">
        <l-map id="gatewayMap" :markers="[{coordinates: lngLat}]">
          <l-cluster :markers="[{eui: gateway.eui, coordinates: lngLat}]"
                     :marker-color="getMarkerColor"
                     :popup-data="['eui']"
                     popup
                     icon="gateway"
                     icon-color="white"
                     popup-content="$0"
          />
        </l-map>
      </div>

      <div class="col-md-4 col-xl-3">
        <div v-if="$store.getters.gatewayFeature(gateway, 'gps')" class="p-2">
          {{ $t('g-position:gpsPositionAllowed') | capitalize }} {{ $t('g-position:' + (gateway.gpsPositionAllowed)) }}
        </div>

        <table v-if="$store.getters.gatewayFeature(gateway, 'gps')" class="table table-sm mb-0">
          <thead>
            <tr><th colspan="2">{{ $t('g-position:remote') | capitalize }}</th></tr>
          </thead>

          <tbody>
            <tr>
              <td class="text-uppercase">{{ $t('g-position:latitude') }}</td>
              <td>{{ gateway.gpsLatitude !== null ? gateway.gpsLatitude : '-' | coordinates }}</td>
            </tr>
            <tr>
              <td class="text-uppercase">{{ $t('g-position:longitude') }}</td>
              <td>{{ gateway.gpsLongitude !== null ? gateway.gpsLongitude : '-' | coordinates }}</td>
            </tr>
            <tr>
              <td class="text-uppercase">{{ $t('g-position:altitude') }}</td>
              <td>{{ gateway.gpsAltitude !== null ? gateway.gpsAltitude : '-' | number('0,0.[00]','',' m') }}</td>
            </tr>
          </tbody>
        </table>

        <table class="table table-sm mb-0">
          <thead>
            <tr><th colspan="2">{{ $t('g-position:manual') | capitalize }}</th></tr>
          </thead>

          <tbody>
            <tr>
              <td class="text-uppercase">{{ $t('g-position:latitude') }}</td>
              <td>{{ gateway.latitude !== null ? gateway.latitude : '-' | coordinates }}</td>
            </tr>
            <tr>
              <td class="text-uppercase">{{ $t('g-position:longitude') }}</td>
              <td>{{ gateway.longitude !== null ? gateway.longitude : '-' | coordinates }}</td>
            </tr>
            <tr>
              <td class="text-uppercase">{{ $t('g-position:altitude') }}</td>
              <td>{{ gateway.altitude !== null ? gateway.altitude : '-' | number('0,0.[00]','',' m') }}</td>
            </tr>
            <tr v-if="nbSatellites">
              <td class="text-uppercase">{{ $t('g-position:nbSatellites') }}</td>
              <td>{{ nbSatellites }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </card>
</template>

<script>
import { get, find } from 'lodash-es'

export default {
  props: {
    gateway: {
      type: Object,
      required: true
    },
    lastStatistics: {
      type: Array,
      required: true
    }
  },

  computed: {
    lngLat () {
      // Uses isFinite to check 0 value
      if (this.gateway.longitude && isFinite(this.gateway.longitude) && this.gateway.latitude && isFinite(this.gateway.latitude)) {
        return [this.gateway.longitude, this.gateway.latitude]
      } else if (this.gateway.gps === 'LOCKED' && this.gateway.gpsLongitude && isFinite(this.gateway.gpsLongitude) && this.gateway.gpsLatitude && isFinite(this.gateway.gpsLatitude)) {
        return [this.gateway.gpsLongitude, this.gateway.gpsLatitude]
      } else {
        return [null, null]
      }
    },
    nbSatellites () {
      return get(find(this.lastStatistics, { name: 'GPS_SATELLITES_NUMBER' }), 'average')
    }
  },

  methods: {
    getMarkerColor () {
      return this.gateway.connection === true
        ? 'green'
        : this.gateway.connection === false
          ? 'red'
          : 'lightgray'
    }
  }
}
</script>

<style scoped lang="scss">
  #gatewayMap {
    height: 330px;
  }
</style>
